import React from 'react';

import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
} from '@mui/material';

import DialogTitle from '../DialogTitle';

/**
 * プロパティ
 */
export type Props = {
  /** 閉じる */
  close: () => void,
  /** タイトル */
  title: string,
  /** コンテンツ */
  content: string,
}

const MessageBoxConfirm: React.FC<Props> = ({
  close,
  title,
  content,
}) => (
  <Dialog
    open
    onClose={() => close()}
  >
    <DialogTitle title={title} />
    <DialogContent>
      <p>{content}</p>
    </DialogContent>
    <DialogActions>
      <Button variant="contained" onClick={() => close()} color="primary">
        閉じる
      </Button>
    </DialogActions>
  </Dialog>
);

export default MessageBoxConfirm;
